import { render, staticRenderFns } from "./UpdatePostModal.vue?vue&type=template&id=731a74ef"
import script from "./UpdatePostModal.vue?vue&type=script&lang=js"
export * from "./UpdatePostModal.vue?vue&type=script&lang=js"
import style0 from "./UpdatePostModal.vue?vue&type=style&index=0&id=731a74ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports